module.exports = __webpack_public_path__ + "img/spool_300.851a262d.png";